(function(){
	if(typeof APPS === 'undefined'){ APPS = {}; }
	APPS.community = {};
	    /*================================================================================
		Router
	 ================================================================================*/
	var Router = Marionette.AppRouter.extend({
		appRoutes: {
			"community": "community"
		}
	})
	
	 /*================================================================================
		Api - called by the Router
	 ================================================================================*/
	var API = {
		community:function(e){
			APPS.community.page.show(e);
		}
	}
	
	APP.on("before:start", function(){
		new Router({
			controller: API
		})
	})
	
})();

